<template>
  <div class="columns">
    <div class="column pricing-quantities">
      <h4 class="title is-4">
        Initial Services
      </h4>
      <o-table class="proposal-pricing-table" :data="projectInitialServices" v-bind="table" :checked-rows="checkedRows"
        @update:checkedRows="$event => checkedRows = $event" @page-change="onPageChange">
        <template>
          <o-table-column v-slot="{ row, index }" :ref="`initial.${index}.title`" field="description"
            label="Description" sortable>
            <input v-model="row.title" type="text" class="dashed-input">
          </o-table-column>

          <o-table-column v-slot="{ row }" field="regularPrice" label="Regular Price" sortable>
            {{ serviceById(row.service_id).price }}
          </o-table-column>

          <o-table-column v-slot="{ row, index }" :ref="`initial.${index}.price`" field="listedPrice"
            label="Listed Price" sortable>
            <input v-model="row.price" type="text" class="dashed-input">
          </o-table-column>

          <o-table-column v-slot="{ row, index }" :ref="`initial.${index}.description`" field="notation"
            label="Notation" class="notation" sortable>
            <!--                        <vue-editor :editor-toolbar="editorToolbar" v-model="projectInitialServices[index + (currentPage - 1) * table.perPage].description"/>-->
            <button id="btn-notation" class="button is-info" @click.prevent="toggleBtn(row)">
              View Description
            </button>
            <div :id="'notation ' + row.id" style="display: none;">
              <quill-editor v-model:content="row.description" :content-type="'html'" />
            </div>
          </o-table-column>

          <o-table-column v-slot="{ row, index }" :ref="`initial.${index}.work_type_price`" field="workTypeCost"
            label="Work Type Cost" sortable>
            <input v-model="row.work_type_price" type="text" class="dashed-input">
          </o-table-column>

          <o-table-column v-slot="{ row }" field="work_types" label="Worktypes #">
            {{ row.work_types.length }}
          </o-table-column>

          <o-table-column v-slot="{ row }" field="worktypeTotal" label="Worktype Total" sortable>
            {{ row.work_type_price * row.work_types.length }}
          </o-table-column>

          <o-table-column v-slot="{ row }" field="totalPrice" label="Total Price" sortable>
            {{ +row.price + (+row.work_type_price * row.work_types.length) }}
          </o-table-column>

          <o-table-column v-slot="{ row }" field="gender" label="Actions">
            <div class="block">
              <a class="button is-danger is-small" @click.prevent="removeService(row)">Delete</a>
            </div>
          </o-table-column>
        </template>
        <template #footer>
          <th>
            Total
          </th>
          <th>
            -
          </th>
          <th label="Regular Price">
            {{ $filters.currency(totalValues.initial.regularPrice) }}
          </th>
          <th label="Listed Price">
            {{ $filters.currency(totalValues.initial.listPrice) }}
          </th>
          <th>
            -
          </th>
          <th label="Work Type Cost">
            {{ $filters.currency(totalValues.initial.workTypeCost) }}
          </th>
          <th label="Worktype #">
            {{ $filters.currency(totalValues.initial.workTypeLength) }}
          </th>
          <th label="Worktype Total">
            {{ $filters.currency(totalValues.initial.workTypeTotal) }}
          </th>
          <th label="Total Price">
            {{ $filters.currency(totalValues.initial.totalPrice) }}
          </th>
          <th>
            -
          </th>
        </template>

        <template #empty>
          <div class="has-text-centered">
            This table is empty!
          </div>
        </template>
      </o-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Table from './../../../mixins/Table'
import { VueEditor } from 'vue2-editor'
import { QuillEditor } from "@vueup/vue-quill";

export default {

  components: {
    QuillEditor
  },

  mixins: [Table],
  props: ['sourceId'],

  computed: {
    ...mapGetters([
      'projectInitialServicesBySource',
      'editorToolbar',
      'serviceById'
    ]),

    projectInitialServices() {
      return this.projectInitialServicesBySource({ source_type: 'change-order', source_id: this.sourceId })
    },
    totalValues() {
      let totalValues = {
        initial: {
          regularPrice: 0,
          listPrice: 0,
          workTypeCost: 0,
          workTypeLength: 0,
          workTypeTotal: 0,
          totalPrice: 0
        },
        optional: {
          regularPrice: 0,
          listPrice: 0,
        }
      }

      // use reduce to add all the values
      totalValues.initial.regularPrice = this.projectInitialServices.reduce((a, b) => +a + +b.price, 0);
      totalValues.initial.listPrice = this.projectInitialServices.reduce((a, b) => +a + +b.price, 0);
      totalValues.initial.workTypeCost = this.projectInitialServices.reduce((a, b) => +a + +b.work_type_price, 0);
      totalValues.initial.workTypeLength = this.projectInitialServices.reduce((a, b) => +a + +b.work_types.length, 0);
      totalValues.initial.workTypeTotal = this.projectInitialServices.reduce((a, b) => +a + +b.work_type_price * b.work_types.length, 0);
      totalValues.initial.totalPrice = this.projectInitialServices.reduce((a, b) => +a + +b.price + +b.work_type_price * b.work_types.length, 0);

      return totalValues;
    }
  },

  methods: {
    ...mapActions(['removeEditingProjectService', 'removeProjectService2', 'createProjectService', 'updateProjectService']),



    validateProjectServices() {
      let valid = true

      _.each(this.projectInitialServices, ps => {
        valid = valid && !(
          !_.isFinite(parseInt(ps.price)) || isNaN(ps.work_type_price) || !ps.title // || !ps.description
        )
      })

      return valid
    },

    toggleBtn(e) {
      document.getElementById('notation ' + e.id).style.display === 'block' ?
        document.getElementById('notation ' + e.id).style.display = 'none' :
        document.getElementById('notation ' + e.id).style.display = 'block';

    },

    onPageChange(page) {
      this.currentPage = page
    },

    removeService(projectService) {
      // if (typeof projectService.id === 'string' && projectService.id.includes('s')) {
      //     this.removeEditingProjectService(projectService)
      // } else {
      //     this.removeProjectService2(projectService)
      // }
      this.$store.state.projectServices.items = this.$store.state.projectServices.items.filter(item => item.id !== projectService.id);

    }
  }
}
</script>
